function isDisabledElement(el) {
  return el.getAttribute("aria-disabled") === "true";
}
function isHiddenElement(el) {
  return el.getAttribute("aria-hidden") === "true";
}
function isFocusableElement(el) {
  return !isDisabledElement(el) && !isHiddenElement(el) && el.offsetParent !== null;
}
function setChildrenFocusability(element, focusable) {
  const focusableElements = element.querySelectorAll(
    'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"]), fabric-button, fabric-link, fabric-input, fabric-card-footer button'
  );
  focusableElements.forEach((child) => {
    const htmlChild = child;
    if (focusable) {
      htmlChild.tabIndex = 0;
    } else {
      htmlChild.tabIndex = -1;
    }
  });
}

function setAttributes(element, attributes) {
  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

function debounce(func, delay) {
  let debounceTimer;
  return function(...args) {
    clearTimeout(debounceTimer);
    debounceTimer = window.setTimeout(() => func.apply(this, args), delay);
  };
}

function createUniqueId(prefix, counter = 0) {
  const randomHex = Math.round((Math.random() + counter) * 65536).toString(16).slice(0, 8);
  return `${prefix}${counter}-${randomHex}`;
}

export { createUniqueId, debounce, isDisabledElement, isFocusableElement, isHiddenElement, setAttributes, setChildrenFocusability };
